
export enum PaymentStatus {
  PAID = "PAID",
  PARTIAL_PAID = "PARTIAL_PAID",
  UNPAID = "UNPAID",

}
